<script>
  export let text
  export let ref
  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button on:click="{() => dispatch('pressed', {ref})}">{text}</button>

<style>
  button {
    border: 2px solid #202020;
    padding: 10px 15px;
    background-color: #FFA01C;
    color: #FDFFFC;
    outline: none;
  }
</style>
